import styled from 'styled-components'
import { backgroundOrange, orange, blackOrange } from '@/theme/colors'
import { Button } from '@components/Button'

/** The sign-in card's Google button: a full-width secondary with the brand mark and a soft orange hairline. */
export const GoogleButton = styled(Button).attrs({ variant: 'secondary' as const, size: 'lg' as const })`
	width: 100%;
	gap: 11px;
	padding: 15px 20px;
	color: ${blackOrange};
	border: 1.5px solid ${orange}33;

	svg {
		width: 19px;
		height: 19px;
		flex: none;
	}

	&:hover:not(:disabled) {
		border-color: ${orange}6b;
		background: ${backgroundOrange};
	}
`
